import { useEffect } from 'react'
import { getSession } from '../api/Assinafy'
import { hasFeature } from '../utils/features'
import { SUBSCRIPTION_UPDATED_EVENT } from '../utils/subscriptionEvents'
import useApiCache from './useApiCache'

// The cached subscription of the current workspace, read again after a plan change.
export const usePlan = () => {
  const accountId = getSession()?.accounts?.[0]?.id
  const { data, error, mutate } = useApiCache(accountId ? 'subscription/view' : null, [accountId])

  useEffect(() => {
    const refresh = () => mutate()
    window.addEventListener(SUBSCRIPTION_UPDATED_EVENT, refresh)
    return () => window.removeEventListener(SUBSCRIPTION_UPDATED_EVENT, refresh)
  }, [mutate])

  return { plan: data || null, error: error ? (error?.data?.message || 'Não foi possível ler o plano.') : '', refresh: mutate }
}

// null while the plan is unknown, then true or false. Hiding writes while unknown is safe: the API
// refuses them without the plan anyway. usePlan().error says when "unknown" is a failure.
const useFeature = (code) => {
  const { plan } = usePlan()

  return plan ? hasFeature(plan, code) : null
}

export default useFeature
